<template>
  <div class="locationComments-list">
    <Row>
       
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
     <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
            <Page ref="listPage" :total="pages.total" :current="pages.page" :page-size="pages.size" show-elevator show-total @on-change="changePage()"></Page>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'locationComments-list',
    data () {
        return {
            loading: true,
            dataloading: true,
            thumblist: [],
            pages:{
                page:1,
                size:10,
                total:0
            },
            title:'',
            formItem:{
                'key':'',
            },
            bigDisplay:'',
            list: [
                {
                    title: 'Id',
                    key: 'id',
                    fixed: 'left',
                    width:90
                },
                {
                    title: '项目名称',
                    key: 'name',
                    minWidth:200,
                    render: (h, params) => {
                        return h('div', [
                            h('span', {
                            }, params.row.location.title)
                        ]);
                    }
                },
                {
                    title: '匠人名称',
                    key: 'tradname',
                    width:100,
                },

                {
                    title: '用户名称',
                    key: 'username',
                    width:100,
                },
                {
                    title: '内容',
                    key: 'comment',
                    minWidth:200
                },
                {
                    title: '评论图片',
                    key: 'attr',
                    width: 200,
                    render: (h, params) => {
                        var that = this;
                        if (params.row.attr == null) {
                                return;
                            }
                        var il = JSON.parse( params.row.attr );
                        var imgListObj = new Array();
                        for (var i = 0; i < il.length; i++) {
                            var showImg = this.$publicData.ossUrl+il[i];
                            imgListObj.push(h('img', {
                                style: {
                                    width: '50px',
                                    height: '50px'
                                },
                                attrs: {
                                    src: showImg
                                },
                                on: {
                                    click: function (e) {
                                        that.visible = true;
                                        that.imgUrl = e.srcElement.src;
                                        that.viewerImages = [e.srcElement.src];
                                        that.$viewer.show();
                                    }
                                }
                            }));
                        }
                        return h('div', imgListObj);
                    }
                },
                {
                    title: '时间',
                    key: 'created_at',
                    width:150
                },
                {
                    title: '操作',
                    key: 'action',
                    width:80,
                    align: 'left',
                    fixed: 'right',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                style:{
                                    marginRight:'8px'
                                },
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.remove(params.index,params.row.id)
                                    }
                                }
                            }, '删除')
                        ]);
                    }
                }
            ],
            tablelist: [],
            locationComments:{
                name:'',
                status:true,
            },
            showModalStatus:false,
            locationCommentsValidate: {
                name: [
                    { required: true, message: '名称必须填写', trigger: 'blur' }
                ],
            },
        }
    },
    created: function () {
        // 取数据
        this.getTableList();
    },
    methods:{
        getTableList:function(){
          this.$api.locationComments.list({"page":this.pages.page,"size":this.pages.size}).then(res=>{
            this.dataloading = false;
            if(res.code == 200) {
                this.tablelist = res.result.list;
                this.pages.total = res.result.total;
                this.$Message.success(res.msg);
            }
          });
          return;
        },
        // 删除
        remove:function(index,id){
            // 弹出确认框
            this.$Modal.confirm({
                title: '警告',
                content: '<p>此操作不可恢复，三思而后行...</p>',
                onOk: () => {
                    this.$api.locationComments.remove({id:id}).then(res=>{
                        if(res.code == 200)
                        {
                            this.$Message.success(res.msg);
                            this.tablelist.splice(index, 1);
                        }
                    });
                }
            });
        },
         // 翻页
        changePage() {
            this.pages.page = this.$refs['listPage'].currentPage;
            this.renderTable(1);
        },
        // 筛选
        renderTable:function(name) {
            if (name !=1){
                this.pages.page = 1;
             }
            this.dataloading = true;
            var ps = {'key':this.formItem.key,"page":this.pages.page,"size":this.pages.size};
            this.$api.locationComments.list(ps).then(res=>{
                this.dataloading = false;
                if(res.code == 200)
                {
                    this.tablelist = res.result.list;
                    this.pages.total = res.result.total;
                    this.$Message.success(res.msg);
                }
            });
            return;
        }
    },
}
</script>
